/* eslint-disable import/no-extraneous-dependencies */
import { decode } from 'jsonwebtoken-esm';

export const retrieveCompanyName = () => window.location.hostname.split('.')[0];
export const retrieveUserData = ({ token }) => decode(token);
